import { Box, Flex, Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ColorPaletteList } from '../ColorPalette';
import { BrandKitRedirectButton } from './BrandKitRedirectButton';
import { Loading } from './Loading';
import { SimpleBrandKitButton } from './SimpleEditBrandKitButton';

interface BrandPalettesProps {
  brandColorPalettes: string[][];
  handleShuffleColors?: (colors: string[], isBrandKit?: boolean) => void;
  hasBrandKitPermission: boolean;
  hasEditBrandKitPermission: boolean;
  isLoading?: boolean;
}

export const BrandPalettes = ({
  hasBrandKitPermission,
  hasEditBrandKitPermission,
  brandColorPalettes,
  isLoading = false,
  handleShuffleColors,
}: BrandPalettesProps) => {
  const [t] = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.brandKit' });

  const onShuffle = useCallback(
    (colors: string[]) => {
      handleShuffleColors?.(colors, true);
    },
    [handleShuffleColors],
  );

  const hasBrandPalettes = brandColorPalettes && brandColorPalettes.length > 0;

  return (
    <Box>
      <Flex alignItems='center' justifyContent='space-between' mb={hasBrandPalettes ? 2 : 4}>
        <Text fontSize='sm' fontWeight='semibold' color='font.500'>
          {t('palettes.heading')}
        </Text>
        <SimpleBrandKitButton hasEditPermission={hasEditBrandKitPermission} ariaLabel={t('editPalettes')} />
      </Flex>
      {!hasBrandPalettes && !isLoading && (
        <BrandKitRedirectButton
          title={t('palettes.addColor')}
          text={t('palettes.addColorText')}
          hasBrandEditPermission={hasEditBrandKitPermission}
        />
      )}
      {isLoading && <Loading />}
      {hasBrandPalettes && !isLoading && (
        <ColorPaletteList
          colorPaletteList={brandColorPalettes}
          hasBrandKitPermission={hasBrandKitPermission}
          onShuffle={onShuffle}
        />
      )}
    </Box>
  );
};
